import { createContext, useContext, type ReactNode } from "react";

export const SSRDataContext = createContext<Record<string, unknown>>({});

export function useSSRData() {
  return useContext(SSRDataContext);
}

export function SSRDataProvider({ 
  value, 
  children 
}: { 
  value: Record<string, unknown>; 
  children: ReactNode;
}) {
  return (
    <SSRDataContext.Provider value={value}>
      {children}
    </SSRDataContext.Provider>
  );
}
